<template>
    <div data-component="AmsListItemHeader">
        <div class="flex justify-between mb-4">
            <div class="text-text">
                {{ locationText }}{{ distanceText ? ',' : '' }}
                <b v-if="distanceText" class="font-bold"> {{ distanceText }} </b>
            </div>
            <cs-tag
                v-if="item.recommended && !hasPriceIndicator"
                :class="{
                    'screen-m:flex': !isVertical,
                }"
                class="hidden"
                :type="Components.CsTag.Type.Recommendation"
            >
                <template #icon> <ms-check-medal /> </template>
                Empfehlung
            </cs-tag>
        </div>
        <h2 class="font-bold break-words text-h3">
            <a ref="link" target="_blank" rel="nofollow noopener" :href="item.url">
                {{ item.title }}
            </a>
        </h2>
    </div>
</template>
<script lang="ts" setup>
import { CsTag } from '@sunrise/components'
import { Components } from '@sunrise/types'
import { PropType, ref } from 'vue'
import { AmsItem } from '../../services/amsSearch/amsSearch.interface'
import { MsCheckMedal } from '@sunrise/icons'

const link = ref<HTMLAnchorElement>()

const props = defineProps({
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
    isVertical: {
        type: Boolean,
        default: false,
    },
    forLocationName: String as PropType<AmsItem['city']>,
    hasPriceIndicator: Boolean,
})

defineExpose({
    anchorLink: link,
})

const locationText = getLocationText(props.item, props.forLocationName)
const distanceText = getDistanceText(props.item, props.forLocationName)

function getLocationText(item: AmsItem, forLocationName?: string) {
    if (item.onlinePurchase) {
        return 'Online-Kauf'
    }

    if (item.city && item.city === forLocationName) {
        return item.city
    }

    return [item.zip, item.city].filter(Boolean).join(' ')
}

function getDistanceText(item: AmsItem, forLocationName?: string) {
    if (
        !item.distance ||
        item.onlinePurchase ||
        props.forLocationName === 'Deutschland' ||
        item.city === forLocationName
    ) {
        return ''
    }

    return `${Math.round(item.distance)} km entfernt`
}
</script>
